import { createFileRoute } from "@tanstack/react-router";
import { AppleSignInButton } from "@/components/AppleSignInButton";
import { Wordmark } from "@/components/Wordmark";

const Landing = () => (
  <main className="flex min-h-screen items-center justify-center px-6 py-12">
    <div className="flex w-full max-w-[440px] flex-col items-center text-center">
      <Wordmark height={40} />

      {/*
        Cover headline verbatim from the Brand Guide (§ Foundations /
        cover). "Personal Media™" is the coined category — rendered in
        Blush per the cover treatment, not italicized (it's the term,
        not an emphasis word).
      */}
      <h1
        className="mt-10 font-serif text-[34px] leading-[42px] text-ink"
        style={{ fontWeight: 600 }}
      >
        The trusted home for your family's{" "}
        <span className="text-blush">Personal Media™</span>
      </h1>

      <p className="mt-5 font-sans text-[15px] leading-[24px] text-ink-soft">
        A quiet, private place to keep and share memories, one moment at a
        time.
      </p>

      <div className="mt-10">
        <AppleSignInButton />
      </div>

      <p className="mt-16 max-w-[260px] font-sans text-[13px] leading-[18px] text-ink-soft/80">
        New to Memily? Download the app to get started. This portal is for
        managing your circle and photos on the web.
      </p>
    </div>
  </main>
);

export const Route = createFileRoute("/")({
  component: Landing,
});
